import { OrganisationTypeConstants } from "../../constants";
import { Origin } from "../../models";
import { logError } from "../../service/error";
import {
  getActivityDashboardTabRoute,
  getActivityReviewDashboardTabRoute,
  getDealListingRoute,
  getDeveloperSettingsMarketingAssetsRoute,
  getDocumentHistoryRoute,
  getProjectAccessDetailsRoute,
  getProjectDetailsByUuid,
  getProjectInventoryRoute,
  getProjectManageProjectGroupRoute,
  getProjectMarketingSettingsRoute,
  getUserEditRouteByUuid,
  getUserSettingsOrganisationRoute,
  getWorkflowTasksBoardRoute,
  getWorkflowTemplatesRoute,
} from "../routes";

export const getAuditObjectLink = (
  detail: string | null,
  objectUuid: string,
  currentUserType: OrganisationTypeConstants,
  origin: Origin,
  relatedProjectUuid?: string
): string => {
  switch (detail) {
    case "Project created":
    case "Project details updated":
    case "Project status updated":
    case "Project standard specific data updated":
    case "Project private standard specific data updated":
      return getProjectDetailsByUuid(objectUuid, currentUserType, { origin });
    case "Project marketing updated":
    case "Project marketing created":
      return getProjectMarketingSettingsRoute(objectUuid, currentUserType, `origin=${origin}`);
    case "Issuances price updated":
    case "Issuance created":
    case "Issuance updated":
    case "Issuance deleted":
    case "Issuance transaction created":
    case "Issuance transaction updated":
      return getProjectInventoryRoute(objectUuid, currentUserType, { origin });
    case "Project access invite created":
    case "Project access invite accepted":
    case "Project access invite rejected":
    case "Project access invite revoked":
    case "Project invite updated":
    case "Project invite resent":
      return relatedProjectUuid
        ? getProjectAccessDetailsRoute(objectUuid, currentUserType, relatedProjectUuid, {
            origin,
          })
        : "";
    case "Organisation user updated":
      return getUserEditRouteByUuid(objectUuid, currentUserType, { origin });
    case "Organisation marketing updated":
    case "Organisation marketing created":
      return getDeveloperSettingsMarketingAssetsRoute({ origin }, objectUuid); // TODO
    case "Organisation details updated":
    case "Organisation address updated":
      return getUserSettingsOrganisationRoute(currentUserType, { origin });
    case "Deal created":
    case "Deal updated":
    case "Deal doc uploaded":
    case "Deal doc deleted":
      return currentUserType === OrganisationTypeConstants.ASSET_MANAGER
        ? getDealListingRoute(objectUuid, currentUserType)
        : "";
    case "Group description updated":
    case "Group project added":
    case "Group project removed":
      return getProjectManageProjectGroupRoute(
        objectUuid,
        `${relatedProjectUuid ? `projectUuid=${relatedProjectUuid}&` : ""}origin=${origin}`
      );
    case "Activity created":
    case "Activity status updated":
    case "Activity published":
    case "Activity cancelled":
      return currentUserType === OrganisationTypeConstants.VERIFIER
        ? getActivityReviewDashboardTabRoute(objectUuid, "documents", `origin=${origin}`)
        : getActivityDashboardTabRoute(objectUuid, "documents", currentUserType, `origin=${origin}`);
    case "Document uploaded":
    case "Document updated":
    case "Document version updated":
      return relatedProjectUuid
        ? getDocumentHistoryRoute(relatedProjectUuid, objectUuid, currentUserType, { origin })
        : "";
    case "Document version deleted":
    case "Activity deleted":
    case "Project deleted":
    case "New user invited":
    case "Activity review status updated":
    case "Activity review updated":
    case "Activity review created":
    case "Project Location created":
    case "Project Location updated":
      return "";
    case "Workflow template created":
    case "Workflow template updated":
    case "Workflow template step added":
    case "Workflow template step removed":
    case "Workflow template step updated":
    case "Workflow template step reordered":
    case "Workflow template task deleted":
    case "Workflow template task created":
    case "Workflow template task updated":
      return getWorkflowTemplatesRoute(currentUserType, objectUuid);
    case "Workflow template applied":
    case "Workflow step added":
    case "Workflow step removed":
    case "Workflow step updated":
    case "Workflow deleted":
    case "Workflow task created":
    case "Workflow task updated":
    case "Workflow task deleted":
    case "Workflow removed":
    case "Workflow updated":
    case "Workflow step reordered":
      return getWorkflowTasksBoardRoute(objectUuid, currentUserType);
    case "Interaction created":
    case "Interaction updated":
    case "Interaction deleted":
    case "Object interactions added or removed":
      return "";
    default:
      logError({ error: `No matching objectType for ${detail}` });
      return "";
  }
};
